import { render } from "./PrintPaymentReceipt.vue?vue&type=template&id=6171d780&scoped=true"
import script from "./PrintPaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PrintPaymentReceipt.vue?vue&type=script&lang=js"

import "./PrintPaymentReceipt.vue?vue&type=style&index=0&id=6171d780&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6171d780"

export default script